import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectCompanyGuid, selectCurrentUserGuid } from "../features/auth/authSlice";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetUnreadNotificationsQuery, useMarkNotificationAsReadMutation, useMarksAllNotificationsAsReadMutation } from "../features/core/notification/api/notificationApiSlice";
import { getDestination, renderContent, renderTitle } from "./commons/NotificationRender";
import TopicSubscriber from "../app/ws/TopicSubriber";
import FormatDate from "utility/FormatDateHour";


const Notifications = (props) => {

    const [t, i18n] = useTranslation(["global"])

    const userGuid = useSelector(selectCurrentUserGuid)
    const companyGuid = useSelector(selectCompanyGuid)
    const [notifications, setNotifications] = useState([])
    const [unreadCount, setUnreadCount] = useState(0)

    const ringSound = new Audio('/assets/audio/notification_ring.wav');
    const clearSound = new Audio('/assets/audio/clear.mp3');

    const {
        data: unreadNotificationsResponse,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetUnreadNotificationsQuery()


    const [marksAllRead, {
        isLoading: markAllReadIsLoading
    }] = useMarksAllNotificationsAsReadMutation()

    const [markAsRead] = useMarkNotificationAsReadMutation()


    useEffect(() => {
        if (isSuccess) {

            let normalizedMsg = unreadNotificationsResponse.map(apiNot =>
            ({
                time: apiNot.timestamp,
                message: {
                    title: apiNot.title,
                    body: apiNot.content,
                    customData: apiNot.customData
                }
            })
            )

            setNotifications(unreadNotificationsResponse)
            setUnreadCount(unreadNotificationsResponse.length)
        }
    }, [isSuccess])

    console.log("Notification Reloaded")

    function handlePayload(payload) {
        ringSound.play();
        payload.message.timestamp = payload.time
        setNotifications(notifications => notifications.concat(payload.message))
        setUnreadCount(unreadCount => unreadCount + 1)
    }


    const handleClear = () => {
        clearSound.play();
        if (notifications.length > 0) {
            marksAllRead()
        }
        setNotifications([])
        setUnreadCount(0)
    }

    const handleOpenDropDown = () => {
        if (unreadCount > 0) {
            setUnreadCount(0)
        }
    }

    return (


        <li className="nav-item dropdown">
            <a className="nav-link show position-relative" onClick={handleOpenDropDown} href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true" data-bs-auto-close="outside">
                {
                    <span className="position-relative top-100 start-50 translate-middle badge rounded-pill bg-danger" style={{ display: unreadCount == 0 ? "none" : null }}>
                        {unreadCount}
                        <span className="visually-hidden">unread messages</span>
                    </span>
                }
                <i className="fa-solid fa-bell"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow navbar-dropdown-caret" id="navbarDropdownNotfication" aria-labelledby="navbarDropdownNotfication" data-bs-popper="static">
                <div className="card position-relative border-0">
                    <div className="card-header p-2">
                        <div className="d-flex justify-content-between">
                            <h6 className="text-body-emphasis mb-0">{t("menu.notifications")}</h6>
                            <button className="btn" onClick={handleClear}><i className="fa-solid fa-eraser"></i></button>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="scrollbar-overlay" data-simplebar="init"><div className="simplebar-wrapper"><div className="simplebar-height-auto-observer-wrapper"><div className="simplebar-height-auto-observer"></div></div><div className="simplebar-mask"><div className="simplebar-offset"><div className="simplebar-content-wrapper" tabIndex={0} role="region" aria-label="scrollable content" ><div className="simplebar-content">
                            {
                                notifications.map(notification => <NotificationRow
                                    key={notification.guid || notification.timestamp}
                                    notification={notification}
                                    onNotificationRead={() => {
                                        if (notification.guid != null) {
                                            markAsRead(notification.guid)
                                        }
                                        const index = notifications.indexOf(notification)
                                        let newArray = [...notifications]
                                        newArray.splice(index, 1)
                                        setNotifications(newArray)
                                    }}
                                />)
                            }
                            <div className="px-2 px-sm-3 py-3 notification-card position-relative read border-bottom" style={{ display: "none" }}>
                                <div className="d-flex align-items-center justify-content-between position-relative">
                                    <div className="d-flex">
                                        <div className="avatar avatar-m status-online me-3"><img className="rounded-circle" src="../../assets/img/team/40x40/30.webp" alt="" /></div>
                                        <div className="flex-1 me-sm-3">
                                            <span className="fs-9 text-body-emphasis">Jessie Samson</span>
                                            <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal"><span className="me-1 fs-10">💬</span>Mentioned you in a comment.<span className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10">10m</span></p>
                                            <p className="text-body-secondary fs-9 mb-0"><svg className="svg-inline--fa fa-clock me-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="clock" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"></path></svg><span className="fw-bold">10:41 AM </span>August 7,2021</p>
                                        </div>
                                    </div>
                                    <div className="d-none d-sm-block"><button className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none notification-dropdown-toggle" type="button" data-bs-toggle="dropdown" data-boundary="window" aria-haspopup="true" aria-expanded="false" data-bs-reference="parent"><svg className="svg-inline--fa fa-ellipsis fs-10 text-body" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path></svg></button>
                                        <div className="dropdown-menu dropdown-menu-end py-2"><a className="dropdown-item" href="#!">Mark as unread</a></div>
                                    </div>
                                </div>
                            </div>

                        </div></div></div></div><div className="simplebar-placeholder" ></div></div><div className="simplebar-track simplebar-horizontal"><div className="simplebar-scrollbar"></div></div><div className="simplebar-track simplebar-vertical"><div className="simplebar-scrollbar"></div></div></div>
                    </div>
                    <div className="card-footer p-0 border-top border-translucent border-0" >
                        <div className="my-2 text-center fs-10 text-body-tertiary text-opactity-85">
                            <NavLink to={{ pathname: "/dashboard/notifications" }} >{t("action.see_all")}</NavLink>

                        </div>
                    </div>
                </div>
            </div>
            <TopicSubscriber
                subTopic={`company/${companyGuid}/user/${userGuid}`}
                onMessageReceived={handlePayload}
            />
        </li>
    )
}


const NotificationRow = ({
    notification,
    onNotificationRead = () => { }
}) => {

    const [t] = useTranslation(["global", "absenceReport"])



    
    return (
        <Link
            to={getDestination(notification)}
            state={{ guid: notification.customData?.objectGuid }}
            style={{ textDecoration: 'none', color: '#212529' }}
            onClick={onNotificationRead}
        >
            <div className="px-3 px-sm-2 py-1 notification-card position-relative read border-bottom">
                <div className="d-flex align-items-center justify-content-between position-relative">
                    <div className="d-flex">
                        <div className="flex-1 me-sm-3">
                            <span className="small">{FormatDate(notification.timestamp)}</span><br />
                            <span className="fs-9 text-body-emphasis"><b>{notification.title}</b></span>
                            <p className="small">{notification.body}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );

}

export default Notifications

